import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useActions from "../../app/hooks";

export default function CreateBookmarkForm(props: {
  open: boolean;
  parentCloseHandle: () => void;
  
  repo_id: number;
  role_id: number;
  view_repo_mode: boolean;
  view_roles_mode: boolean;
  repo_path: string;

  folder_id: number;
  folder_stack: string;
  folder_names: string;
}) {
  const actions = useActions();

  const [name, setName] = useState("");
  const [nameError, setNameError] = React.useState("Name");

  function createDash() {
    const newDash = {
      name: name,
      repo_id: props.repo_id,
      role_id: props.role_id,
      view_repo_mode: props.view_repo_mode,
      view_roles_mode: props.view_roles_mode,
      repo_path: props.repo_path,

      folder_id: props.folder_id,
      folder_stack: props.folder_stack,
      folder_names: props.folder_names,
    };
    actions.createBookmark(newDash);
    props.parentCloseHandle();
  }

  function handleNameChange(e: any) {
    if (e.target.value.trim() === "") {
      setNameError("Invalid name");
    } else setNameError("");
    setName(e.target.value);
  }

  return (
    <Dialog open={props.open} onClose={() => props.parentCloseHandle()}>
      <DialogTitle>New Bookmark</DialogTitle>
      <DialogContent>
        <DialogContentText>Create a new bookmark</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Name"
          error={nameError !== ""}
          fullWidth
          variant="standard"
          onChange={handleNameChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.parentCloseHandle()}>Cancel</Button>
        <Button
          onClick={createDash}
          type="submit"
          variant="contained"
          color="primary"
          disabled={nameError !== ""}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
